import { Controller } from "stimulus"

function getCsrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : ''
}

export default class extends Controller {
  static targets = ["content", "icon", "body", "header"]
  static values = { open: Boolean }

  connect() {
    this.updateState()
  }

  toggle(event) {
    // Prevent event bubbling so header click doesn't also trigger
    if (event) {
      event.stopPropagation()
    }
    this.openValue = !this.openValue
    this.updateState()
    this.saveState()
  }

  // Expand when clicking on header (only if collapsed)
  expandFromHeader(event) {
    if (!this.openValue) {
      this.openValue = true
      this.updateState()
      this.saveState()
    }
  }

  updateState() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("collapsed", !this.openValue)
    }

    if (this.hasBodyTarget) {
      this.bodyTarget.classList.toggle("collapsed", !this.openValue)
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-chevron-up", this.openValue)
      this.iconTarget.classList.toggle("fa-chevron-down", !this.openValue)
    }

    if (this.hasHeaderTarget) {
      this.headerTarget.classList.toggle("learning-header-collapsed", !this.openValue)
    }
  }

  saveState() {
    const csrfToken = getCsrfToken()

    fetch('/learning_options/toggle_dashboard_card', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    })
  }
}
